import React from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';

export const Unauthorized = () => {
    const history = useHistory();

    return (
        <div className="exception-body accessdenied">
            <div className="exception-panel">
                <div className="exception-content">
                    <h1>Unauthorized</h1>
                    <p>You don't have permission to access this page.</p>
                    <Button label="Go to Dashboard" onClick={() => history.push('/')} />
                </div>
            </div>
        </div>
    );
};
